import { configureStore } from '@reduxjs/toolkit';
import { uiSlices } from './slices/uiSlice';
import { mapSlices } from './slices/mapSlice';
import { settingsReducer } from './slices/settingsSlice';
import { flowersReducer } from './slices/flowersSlice';
import { networkingReducer } from './slices/networkingSlice';
import { notificationsReducer } from './slices/notificationsSlice';
import { giftsReducer } from './slices/giftsSlice';

export const store = configureStore({
    reducer: {
        ui: uiSlices,
        map: mapSlices,
        settings: settingsReducer,
        flowers: flowersReducer,
        networking: networkingReducer,
        notifications: notificationsReducer,
        gifts: giftsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Игнорируем эти action types в проверке сериализации
                ignoredActions: ['persist/PERSIST'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;